import { routes } from "schemas/routes";

import { isPage } from "utils/general";

// Event names
export const PAGE_VISITED = "Page Visited";
export const BRAND_PAGE_VISITED = "Brand Page Visited";

// Page Names
export const HOME_PAGE = "Home";
export const INBOX_PAGE = "Inbox";
export const PROJECTS_PAGE = "Projects";
export const SETTINGS_PAGE = "Settings";
export const DISCOVER_PAGE = "Discover";
export const TEMPLATES_PAGE = "Templates";
export const ONBOARDING_FORM_PAGE = "Onboarding";
export const SELF_SERVE_ONBOARDING_PAGE = "Self Serve Onboarding";
export const INSTAGRAM_ONBOARDING_PAGE = "Instagram Onboarding";
export const TRACKING_PAGE = "Tracking";
export const PROFILE_PAGE = "Profile";
export const RECOMMENDATIONS_PAGE = "Recommendations";
export const SUBSCRIPTIONS_PAGE = "Subscriptions Checkout Page";
export const CAMPAIGNS_PAGE = "Campaigns";
export const LOCAL_PITCH_PAGE = "Local Pitching";
export const PITCH_PLEASE = "Oui We Studio Pitch Please";
export const PRO_BUNDLE = "Pro Bundle";
export const VIRTUAL_ASSISTANT_DASHBOARD = "VA Dashboard";
export const FAIRPAY = "Fair Pay";
export const ANNUAL_SPLASH_PAGE = "Annual Splash Page";

export const getPageName = () => {
  if (isPage(routes.fairpay)) {
    return FAIRPAY;
  } else if (isPage(routes.home)) {
    return HOME_PAGE;
  } else if (isPage(routes.inbox)) {
    if (isPage(routes.inboxScheduled)) {
      return "Scheduled Emails";
    } else if (isPage(routes.inboxSent)) {
      return "Sent Emails";
    } else if (isPage(routes.inboxCheckins)) {
      return "Check-ins";
    }
    return INBOX_PAGE;
  } else if (isPage(routes.settings)) {
    return SETTINGS_PAGE;
  } else if (isPage(routes.brands)) {
    return DISCOVER_PAGE;
  } else if (isPage(routes.templates)) {
    return TEMPLATES_PAGE;
  } else if (isPage(routes.onboardingInstagram)) {
    return INSTAGRAM_ONBOARDING_PAGE;
  } else if (isPage(routes.onboarding)) {
    return ONBOARDING_FORM_PAGE;
  } else if (isPage(routes.tracking)) {
    return TRACKING_PAGE;
  } else if (isPage(routes.profile)) {
    return PROFILE_PAGE;
  } else if (isPage(routes.recommendations)) {
    return RECOMMENDATIONS_PAGE;
  } else if (isPage(routes.subscriptions)) {
    return SUBSCRIPTIONS_PAGE;
  } else if (isPage(routes.campaignView)) {
    return CAMPAIGNS_PAGE;
  } else if (isPage(routes.pitchLocal)) {
    return LOCAL_PITCH_PAGE;
  } else if (isPage(routes.onboardingVaSelfServe)) {
    return SELF_SERVE_ONBOARDING_PAGE;
  } else if (isPage(routes.pitchPlease)) {
    return PITCH_PLEASE;
  } else if (isPage(routes.proBundle)) {
    return PRO_BUNDLE;
  } else if (isPage(routes.virtualAssistant)) {
    return VIRTUAL_ASSISTANT_DASHBOARD;
  } else if (isPage(routes.annual)) {
    return ANNUAL_SPLASH_PAGE;
  } else {
    return "";
  }
};
